














import {Component} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import ManageFeeNotYetPayCustomerTable
    from "@/modules/managefeecustomer/ListNotYetPay/components/ManageFeeNotYetPayCustomerTable/index.vue";
import {ManageFeeStore} from "@/modules/managefeecustomer/store";
import {ManageFeeParams} from "@/modules/managefeecustomer/params";
import ManageFeeNotYetPayCustomerExcel
    from "@/modules/managefeecustomer/ListNotYetPay/components/ManageFeeNotYetPayCustomerExcel/index.vue";
import TableToExcel from "@linways/table-to-excel";

@Component({
    name: 'ManageFeeCustomerNotYetPay',
    components: {ManageFeeNotYetPayCustomerExcel, ManageFeeNotYetPayCustomerTable}
})
export default class extends mixins(CommonMixin) {
    params = new ManageFeeParams();
    isExporting = false;
    created() {
        ManageFeeStore.paramNotPayManageFeeChange(this.params);
    }
    async exportExcel() {
        this.isExporting = true;
        await ManageFeeStore.exportExcelNotPay(this.params);
        this.isExporting = false;
        setTimeout(() => {
            TableToExcel.convert(document.getElementById("table-excel-not-yet-pay"), {
                name: `Danh sách đơn.xlsx`,
                sheet: {
                    name: "Sheet 1"
                }
            }, 800);
        })
    }
}
